export default function singleOrMultiple(text, amount) {
  if (amount === 1) {
    return text;
  }

  return `${text}s`;
}



// WEBPACK FOOTER //
// ./library/app/utils/singleOrMultiple.js